import React, { useCallback, useContext, useEffect } from 'react'
import { isBedbank, isLEHotel, isTourV1Offer, isTourV2Offer } from 'lib/offer/offerTypes'
import BedbankCard from 'tripPlanner/components/Bookmark/BookmarkCard/BedbankCard'
import LEOfferCard from 'tripPlanner/components/Bookmark/BookmarkCard/LEOfferCard'
import TourBookmarkCard from 'tripPlanner/components/Bookmark/BookmarkCard/TourBookmarkCard'
import TourV2Card from 'tripPlanner/components/Bookmark/BookmarkCard/TourV2Card'
import { productClick, productImpressionSnowplow } from 'analytics/enhanced-ecommerce'
import { productClickObject, productImpressionObject } from 'analytics/eventDefinitions'

import { useInView } from 'react-intersection-observer'
import { TrackingProps } from 'contexts/trackingContext'
import CurrencyContext from 'contexts/currencyContext'
import useOffer from 'hooks/Offers/useOffer'
import TopPicksForMeOfferSkeleton from './TopPicksForMeOfferSkeleton'
import styled from 'styled-components'

const Tile = styled.div`
  height: 100%;

  > * {
    height: 100%;
  }
`

interface TrackedOfferProps {
  position: number;
  offerId: string;
  linkQuery?: URLSearchParams;
  trackingProps: TrackingProps;
  preload: boolean;
  onClick?: () => void;
}

function TopPicksForMeCarouselOffer(props: TrackedOfferProps) {
  const { offerId, position, linkQuery, trackingProps, preload, onClick } = props
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
    rootMargin: '200px',
  })
  const [offer] = useOffer(offerId, { disabled: !preload && !inView })
  const currency = useContext(CurrencyContext)

  useEffect(() => {
    if (inView && offer) {
      productImpressionSnowplow(
        currency,
        [productImpressionObject(offer, trackingProps.listName!, position)],
        {
          listId: trackingProps.listId!,
          listName: trackingProps.listName!,
        },
      )
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, offer])

  const onTileClick = useCallback(() => {
    if (offer) {
      onClick?.()
      productClick(
        currency,
        productClickObject(offer, position),
        {
          listId: trackingProps.listId!,
          listName: trackingProps.listName!,
        },
        trackingProps.lere?.version,
      )
    }
  }, [trackingProps, currency, position, offer, onClick])

  return <Tile
    ref={inViewRef}
  >
    {!offer && <TopPicksForMeOfferSkeleton />}
    {offer && <>
      {isBedbank(offer) && <BedbankCard offer={offer}
        onClick={onTileClick}
        linkQuery={linkQuery}
        aspectRatio="2:1"
        target="_blank"
      />}
      {isTourV2Offer(offer) && <TourV2Card
        offer={offer}
        onClick={onTileClick}
        linkQuery={linkQuery}
        aspectRatio="2:1"
        target="_blank"
      />}
      {isTourV1Offer(offer) && <TourBookmarkCard
        offer={offer}
        onClick={onTileClick}
        linkQuery={linkQuery}
        aspectRatio="2:1"
        target="_blank"
      />}
      {isLEHotel(offer) && <LEOfferCard
        offer={offer}
        onClick={onTileClick}
        linkQuery={linkQuery}
        aspectRatio="2:1"
        target="_blank"
        shouldProcessOfferUrgencyLabel
      />}
    </>}
  </Tile>
}

export default TopPicksForMeCarouselOffer
